import { render, staticRenderFns } from "./mapLegend1.vue?vue&type=template&id=a2ba3f60&scoped=true&"
import script from "./mapLegend1.vue?vue&type=script&lang=js&"
export * from "./mapLegend1.vue?vue&type=script&lang=js&"
import style0 from "./mapLegend1.vue?vue&type=style&index=0&id=a2ba3f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ba3f60",
  null
  
)

export default component.exports